import * as amplitude from "@amplitude/analytics-browser";

// Só o `initAmplitude` conhece a chave, então é ele quem sabe se existe um
// cliente de verdade do outro lado. Sem isto, com a chave vazia (dev local, ou
// um ambiente antes do secret entrar no Vault), todo caminho de login chamaria
// um cliente não inicializado.
let initialized = false;

export const isAmplitudeReady = () => initialized;

export const initAmplitude = (apiKey?: string) => {
  if (!apiKey) return;

  // A org paga overage por evento (US$ 0,00009 cada, ~US$ 9 por 100 mil), então
  // o admin sobe sem nenhuma captura automática: só os eventos que o código
  // dispara de propósito saem daqui. Cada chave que o SDK liga por padrão está
  // desligada explicitamente, porque num objeto o que não é citado vale `true`.
  // `pageUrlEnrichment` é a exceção e fica ligado de propósito: ele não gera
  // evento, só carimba `[Amplitude] Page Domain` nos que existem, que é o que
  // separa o admin do CPMS no mesmo projeto.
  //
  // Religar captura não precisa de deploy: `fetchRemoteConfig` fica no default
  // e o remoto vence o local chave a chave, pela tela de autocapture do
  // Amplitude. Lá, use as chaves granulares: um `autocapture` booleano vindo do
  // painel substitui o objeto inteiro e, como a configuração remota é por chave
  // de API, levaria junto o `attribution: false` do tupi-cpms-frontend.
  const options = {
    autocapture: {
      attribution: false,
      fileDownloads: false,
      formInteractions: false,
      pageViews: false,
      sessions: false,
      pageUrlEnrichment: true,
    },
  };

  amplitude.init(apiKey, options);
  initialized = true;
};
